module.exports = __webpack_public_path__ + "static/media/Pattern14.65528569.png";